module.exports = __webpack_public_path__ + "static/media/MENU_CATALOGOS.18136378.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/MENU_CATALOGOS.svg
// module id = 492
// module chunks = 0